import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { HttpService } from 'src/app/http.service';
import { ImageUploaderComponent } from 'src/app/image-uploader/image-uploader.component';

@Component({
  selector: 'app-transfer-game-form',
  templateUrl: './transfer-game-form.component.html',
  styleUrls: ['./transfer-game-form.component.scss']
})
export class TransferGameFormComponent {

  public data: any = {status: 1, game_method: 'normal'}
  public providers:any = [];
  public provider_categories:any = []
  public categories:any = []
  public games:any = []
  public permission:any = {};
  private game_uuid:any;
  public company_uuid:any;

  // Per-tile image overrides shown on the transfer-game page. Each row:
  // { game_id, name, image (primary/fallback), images: { en, cn, ms } (per-language overrides) }.
  public gameImages:any[] = [];
  public tilesLoading = false;

  // Language variants offered per tile. `image` (primary) is the fallback shown when the active
  // front language has no variant. Mirrors the front's supported languages (en/cn/ms).
  public imageLangs:any[] = [
    { code: 'en', title: 'EN' },
    { code: 'cn', title: '中文' },
    { code: 'ms', title: 'BM' },
  ];

  @ViewChild('f') f : NgForm
  @ViewChild("imageUploader", {static: true}) imageUploader : ImageUploaderComponent;

  constructor(private http: HttpService, private route: ActivatedRoute) { 
    const uuid: Observable<string> = this.route.params.pipe(map(p => p['uuid']));
    this.permission = this.http.getSelecetdCompanyDetail();
    this.company_uuid = this.http.getStaticSelectedCompany();
    uuid.subscribe(val => {
      if(val) {
        this.init(val)
        this.game_uuid = val;
      }

    })

    this.initIntegration()
    this.getGames();
    this.initGamesCategory();
  }

  async init(uuid) {
    this.data = await this.http.post('/admin/setting/game/get', {uuid});

    if(this.data.image) {
      this.imageUploader.files = [this.data.image]
    }

    if(!this.data.parent_id) {
      this.data.game_method = 'normal'
    } else {
      this.data.game_method = 'child'
    }

    this.loadGameImages();
    this.checkIfCurrentProviderHaveCategory();

  }

  loadGameImages() {
    let raw = this.data.game_images;
    if (!raw) {
      this.gameImages = [];
      return;
    }
    try {
      let parsed = typeof raw === 'string' ? JSON.parse(raw) : raw;
      this.gameImages = Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      this.gameImages = [];
    }
    // Older rows have no `images` map; ensure one exists so the per-language uploaders bind cleanly.
    this.gameImages.forEach((row:any) => { if (!row.images || typeof row.images !== 'object') row.images = {}; });
  }

  addImageRow() {
    this.gameImages.push({ game_id: '', name: '', image: '', images: {} });
  }

  removeImageRow(i:number) {
    this.gameImages.splice(i, 1);
  }

  onRowImage(i:number, files:any) {
    this.gameImages[i].image = (files && files.length) ? files[0] : '';
  }

  onRowImageDelete(i:number) {
    this.gameImages[i].image = '';
  }

  onRowLangImage(i:number, code:string, files:any) {
    if (!this.gameImages[i].images) this.gameImages[i].images = {};
    this.gameImages[i].images[code] = (files && files.length) ? files[0] : '';
  }

  onRowLangImageDelete(i:number, code:string) {
    if (this.gameImages[i].images) this.gameImages[i].images[code] = '';
  }

  async loadTiles() {
    if (!this.game_uuid) {
      alert("Please save the game first, then load its tiles.");
      return;
    }
    this.tilesLoading = true;
    let rtn:any = await this.http.post('/admin/transfer/game/tiles', { uuid: this.game_uuid });
    this.tilesLoading = false;

    if (!rtn || !rtn.status || !rtn.tiles || rtn.tiles.length == 0) {
      alert((rtn && rtn.message) ? rtn.message : "No game tiles available for this provider. You can add rows manually.");
      return;
    }

    // Merge: keep any existing rows, add provider tiles that aren't already present.
    let norm = (v:any) => (v == null ? '' : String(v).trim().toLowerCase());
    for (let t of rtn.tiles) {
      let exists = this.gameImages.find((o:any) =>
        (norm(o.game_id) && norm(o.game_id) === norm(t.game_id)) ||
        (norm(o.name) && norm(o.name) === norm(t.name))
      );
      if (!exists) {
        this.gameImages.push({ game_id: t.game_id || '', name: t.name || '', image: t.image || '', images: {} });
      } else if (t.image && !exists.image) {
        exists.image = t.image;
      }
    }
  }

  async getGames() {
    let games:any = await this.http.post("/admin/transfer/game/get");
    this.games = games.filter((v:any) => {
      return !v.parent_id
    })
  }

  async initIntegration() {
    this.providers = await this.http.post("/admin/integration/v2", {status: 1, integration_mode: 'transfer'});

    if(!this.data.integration_id) {
      this.data.integration_id = null;
    }
  }

  checkIfCurrentProviderHaveCategory() {

    if(!this.data.integration_id) {
      return;
    }

    let y = this.providers.find((v:any) => {
      return v.id == this.data.integration_id
    })

    if(!y || !y.category) {
      this.provider_categories = []
      return;
    }

    this.provider_categories = y.category;
    
  }

  checkIfCurrentProviderHaveCategoryParent() {
  


    let game = this.games.find((v:any) => {
      return v.id == this.data.parent_id
    })

    let y = this.providers.find((v:any) => {
      return v.id == game.provider_category_id
    })
    
    console.log("_______hello", y)
    if(!y || !y.category) {
      this.provider_categories = []
      return;
    }

    this.provider_categories = y.category;
  }

  async initGamesCategory() {
    this.categories = await this.http.post("/admin/app/game/category/init");
  }

  async submit(stay = false) {
    this.data.game_images = this.gameImages.filter((o:any) => o && o.image && (o.game_id || o.name));
    await this.http.post('/admin/transfer/game/update', this.data);

    if(stay) {
      return;
    }

    if (this.data.uuid) {
      this.http.navigate(['/lo',this.http.getStaticSelectedCompany(),'transfer-game-setting'])
      return;
    }
    
    await this.f.resetForm({status: 1});
  }

  async upload(v:any) {
    this.data.image = v[0];
  }

  removeImage() {

    if(!this.game_uuid) {
      return;
    }

    delete this.data.image;
    this.submit(true);
  }

  editorCreated(quill: any, param:any) {
    setTimeout(() => {
      quill.clipboard.dangerouslyPasteHTML(this.data[param]);
    }, 100)
  }

}
